<template>
    <b-modal
        id="modal-error-number-doses"
        no-close-on-backdrop
        no-close-on-esc
        hide-header
        hide-footer
        centered
        v-model="modalShow"
    >
        <div class="d-flex flex-column align-items-center justify-center-center my-2">
            <feather-icon
                id="modal-erro-doses"
                icon="AlertCircleIcon"
                class="text-danger mb-2"
                size="80"
            />
            <h3>{{ title ? title : 'Departamento incompleto' }}</h3>
            <div class="text-center">
                <span>{{ infoTextModal }}</span>
            </div>
            <div class="d-flex mt-2">
                <b-button :disabled="loading" variant="custom-blue" @click="confirmAction" >
                    <span v-if="loading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                        {{ action }}
                </b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue';
export default {
    components: {
        BModal, BButton
    },

    props: {
        modalShow: {
            required: true,
            type: Boolean
        },
        typeModal: {
            required: true,
            type: String
        },
        infoText: {
            type: String
        }
    },

    data() {
        return {
            loading: false,
            modalTypes: [
                {
                    'title': 'Departamento sem definição de região',
                    'type': 'sem-regiao',
                    'action': 'Ok!',
                    'infoText': `Para a campanha ser criada é necessária a configuração do uso ou não de regiões. 
                    Você será redirecionado para a tela de configuração do uso ou não de regiões.
                    Logo após, será possível a criação da campanha.`
                },
                {
                    'title': 'Departamento sem unidade cadastrada',
                    'type': 'sem-unidade',
                    'action': 'Ok!',
                    'infoText': `Para a distribuição de doses nas unidades é necessária, ao menos, uma unidade criada e ativa.
                    Você será redirecionado para a tela de unidades.
                    Logo após, será possível editar a campanha para a distribuição de doses nas unidades.`
                },
                {
                    'title': 'Departamento sem definição de região',
                    'type': 'sem-regiao-criacao-unidade',
                    'action': 'Ok!',
                    'infoText': `Para a unidade ser cadastrada é necessária a configuração do uso ou não de regiões. 
                    Você será redirecionado para a tela de configuração do uso ou não de regiões.
                    Logo após, será possível o cadastro da unidade.`
                },
                {
                    'title': 'Departamento sem definição de região',
                    'type': 'sem-regiao-criacao-empresa',
                    'action': 'Ok!',
                    'infoText': `Para a empresa ser cadastrada é necessária a configuração do uso ou não de regiões. 
                    Você será redirecionado para a tela de configuração do uso ou não de regiões.
                    Logo após, será possível o cadastro da empresa.`
                },
            ],
            type: '',
            title: null,
            action: '',
            infoTextModal: ''
        }
    },

    methods: {
        confirmAction(modalEvent) {
            modalEvent.preventDefault();

            this.loading = true;

            this.$emit('confirmed', modalEvent);
        }
    },

    watch: {
        modalShow() {
            this.loading = false;

            this.modalTypes.map(item => {
                if(item.type == this.$props.typeModal) {
                    this.action = item.action;
                    this.title = item.title ? item.title : null;
                    this.infoTextModal = item.infoText;
                }
            });
        }
    }
}
</script>

